var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"page-content"},[_c('img',{attrs:{"src":require("@/assets/images/success.png"),"alt":""}}),_c('div',{staticClass:"tip"},[_vm._v("您的账号已经成功绑定")])])])
}]

export { render, staticRenderFns }